var _clipPath, _path, _g, _path2, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 600,
    height: 300,
    viewBox: "0 0 120 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0v15h70v15H60zm0 30v10h30V0h30z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#012169",
    d: "M0 0h120v60H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#c8102e",
    strokeWidth: 6
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    d: "m0 0 60 30m0-30L0 30"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 4,
    d: "m0 0 60 30m0-30L0 30",
    clipPath: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 10,
    d: "M30 0v40M0 15h70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 0v40M0 15h70"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fedd00",
    d: "M60 0h60v60H0V30h60z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(30,15)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(5.10390485)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 1,
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    id: "b",
    fill: "#fedd00",
    d: "m0-513674 301930 929245-790463-574305h977066l-790463 574305",
    transform: "scale(0.00000194676)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    transform: "translate(-17.5,0.29) scale(3)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    transform: "translate(17.5,0.29) scale(3)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    transform: "translate(0,10.29) scale(3)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    transform: "translate(0,-9.71) scale(3)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNu);
export default __webpack_public_path__ + "static/media/nu.bd8f0991303e68f0a5806325870748ad.svg";
export { ForwardRef as ReactComponent };